import React from 'react'
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import AllAcountsSection from '../../Components/AllAccountsSection/AllAcountsSection'
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
// import Arrow_down from "../../assets/images/IZB/arrow_down.png";
import { AiOutlineArrowRight } from "react-icons/ai";
import { question } from './LeaseData';
import LeaseAccoudion from './LeaseAccoudion';
import { useEffect } from 'react';

const LeaseRentalDiscounting = () => {
const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Lease.jpg";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/lease-rental-banner.png";

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const accountContent = "Need ﬁnancing against future receivables. We have your back."
  return (
    <>
    <Breadcrumb Heading="Lease Rental Discounting IZB" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent
        heading="Lease Rental Discounting IZB"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      {/* <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#benefits">
                        <img src={Arrow_down} className="me-1" />
                        Eligibility
                      </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section id="MSMEAccodion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box mb-5">
              {question.map((item) => {
                const { id } = item;
                return <LeaseAccoudion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>

    <AllAcountsSection/>
    </>
  )
}

export default LeaseRentalDiscounting